import { Calendar, BarChart, ShoppingBag, Trophy } from 'lucide-react';

export default function AdminStats({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
      <div data-testid="stat-events" className="bg-card border border-border p-6 rounded-lg">
        <Calendar className="w-8 h-8 text-accent mb-3" />
        <p className="text-sm uppercase tracking-widest font-bold text-primary mb-1">Eventos</p>
        <p className="text-3xl font-bold text-foreground">{stats.total_events}</p>
      </div>
      <div data-testid="stat-registrations" className="bg-card border border-border p-6 rounded-lg">
        <BarChart className="w-8 h-8 text-accent mb-3" />
        <p className="text-sm uppercase tracking-widest font-bold text-primary mb-1">Inscrições</p>
        <p className="text-3xl font-bold text-foreground">{stats.total_registrations}</p>
      </div>
      <div data-testid="stat-products" className="bg-card border border-border p-6 rounded-lg">
        <ShoppingBag className="w-8 h-8 text-accent mb-3" />
        <p className="text-sm uppercase tracking-widest font-bold text-primary mb-1">Produtos</p>
        <p className="text-3xl font-bold text-foreground">{stats.total_products}</p>
      </div>
      <div data-testid="stat-orders" className="bg-card border border-border p-6 rounded-lg">
        <Trophy className="w-8 h-8 text-accent mb-3" />
        <p className="text-sm uppercase tracking-widest font-bold text-primary mb-1">Pedidos</p>
        <p className="text-3xl font-bold text-foreground">{stats.total_orders}</p>
      </div>
    </div>
  );
}
